export const showMaxCharWarning = (
  maxCharLimit: number,
  inputLength: number,
  warningRange: number
): boolean => inputLength > maxCharLimit - warningRange && inputLength <= maxCharLimit;

export const showMinCharError = (minCharLimit: number, inputLength: number): boolean =>
  inputLength < minCharLimit;

export const showMaxCharError = (maxCharLimit: number, inputLength: number): boolean =>
  inputLength > maxCharLimit;
